import { CapoPlugin } from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];